import { Link } from "react-router-dom";
import "../styles/landing.css";

export type LegalSection = { heading: string; body: string };

/* Renders a draft legal document (Privacy/Terms) from the legal council's
   content. Body blocks split on blank lines; lines starting with "- " become a
   list. Em-dashes are kept (legal prose). Content is DRAFT — see decision 0005. */
export default function LegalDoc({
  title,
  sections,
}: {
  title: string;
  sections: LegalSection[];
}) {
  return (
    <div className="landing">
      <div className="lp-legal">
        <Link to="/" className="lp-nav-link">&larr; Back to home</Link>
        <h1>{title}</h1>
        {sections.map((s, i) =>
          i === 0 ? (
            <div className="lp-draft" key={s.heading}>
              {renderBlocks(s.body)}
            </div>
          ) : (
            <section key={s.heading}>
              <h2>{s.heading}</h2>
              {renderBlocks(s.body)}
            </section>
          )
        )}
      </div>
    </div>
  );
}

function renderBlocks(body: string) {
  return body
    .split(/\n\n+/)
    .map((block, i) => {
      const lines = block.split("\n");
      if (lines.every((l) => l.trim().startsWith("- "))) {
        return (
          <ul key={i}>
            {lines.map((l, j) => (
              <li key={j}>{l.trim().replace(/^- /, "")}</li>
            ))}
          </ul>
        );
      }
      return <p key={i}>{block}</p>;
    });
}
